// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 70) return "js/70-b97387f039afc51d.js";
  // return url for filenames based on template
  return "js/" + ({592: "logrocket",712: "echarts",}[chunkId] || chunkId) + "-" + {321: "6da81fbc1060bfee",43: "e6d78e8b11c02f6c",580: "3e3f63c90110c6ce",592: "391a9ca13585c76e",696: "0faf73d09c029410",712: "b22f512c380015fd",}[chunkId] + ".chunk.js"
}